import { render, staticRenderFns } from "./VacancyListItem.vue?vue&type=template&id=2c605e32"
import script from "./VacancyListItem.vue?vue&type=script&lang=js"
export * from "./VacancyListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports